import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject8(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Ciudades capitales del mundo");
    await safeDeleteSheet(context, "Top 15 Ciudades");

    // ─── SHEET 1: Ciudades capitales del mundo ───
    const sheet1 = context.workbook.worksheets.add("Ciudades capitales del mundo");

    const headers: string[] = ["País", "Ciudad Capital", "Población", "Clasificación"];

    const data: (string | number)[][] = [
      ["Afghanistan","Kabul",2206300,54],
      ["Albania","Tirana",353400,136],
      ["Algeria","Algiers",3917000,30],
      ["Andorra","Andorra la Vella",23000,183],
      ["Angola","Luanda",2297200,52],
      ["Antigua and Barbuda","St. John's",23500,182],
      ["Argentina","Buenos Aires",13349000,4],
      ["Armenia","Yerevan",1462700,79],
      ["Australia","Canberra",327700,141],
      ["Austria","Vienna",2041300,58],
      ["Azerbaijan","Baku",2118600,57],
      ["Bahamas","Nassau",222200,150],
      ["Bahrain","Al-Manámah",527000,130],
      ["Bangladesh","Dhaka",12560000,6],
      ["Barbados","Bridgetown",98900,163],
      ["Belarus","Mensk",1769500,64],
      ["Belgium","Brussels",1750600,67],
      ["Belize","Belmopan",8700,189],
      ["Benin","Porto-Novo",231600,148],
      ["Bhutan","Thimphu",60200,172],
      ["Bolivia","Sucre",204200,152],
      ["Bosnia and Herzegovina","Sarajevo",581500,126],
      ["Botswana","Gaborone",195000,154],
      ["Brazil","Brasília",2160100,55],
      ["Brunei","Bandar Seri Begawan",78000,167],
      ["Bulgaria","Sofia",1088700,97],
      ["Burkina Faso","Ouagadougou",962100,100],
      ["Burundi","Bujumbura",331700,140],
      ["Cambodia","Phnom Penh",1169800,92],
      ["Cameroon","Yaoundé",1395200,83],
      ["Canada","Ottawa",1142700,94],
      ["Cape Verde","Praia",99400,162],
      ["Central African Republic","Bangui",810000,107],
      ["Chad","N'Djamena",609600,122],
      ["Chile","Santiago",5333100,24],
      ["China","Beijing",10849000,10],
      ["Colombia","Santafé de Bogota",7594000,17],
      ["Comoros","Moroni",60200,173],
      ["Congo, Democratic Republic of the","Kinshasa",6541300,21],
      ["Congo, Republic of","Brazzaville",1169900,91],
      ["Costa Rica","San José",1527300,76],
      ["Côte d'Ivoire","Yamoussoukro",185600,157],
      ["Croatia","Zagreb",685500,118],
      ["Cuba","Havana",2686000,45],
      ["Cyprus","Lefkosia",197600,153],
      ["Czech Republic","Prague",1378700,87],
      ["Denmark","Copenhagen",1094400,96],
      ["Djibouti","Djibouti",383000,134],
      ["Dominica","Roseau",20000,186],
      ["Dominican Republic","Santo Domingo",2851300,40],
      ["East Timor","Dili",50800,174],
      ["Ecuador","Quito",1780700,63],
      ["Egypt","Cairo",11146000,9],
      ["El Salvador","San Salvador",1791700,62],
      ["Equatorial Guinea","Malabo",92900,164],
      ["Eritrea","Asmara",899000,104],
      ["Estonia","Tallinn",379000,135],
      ["Ethiopia","Addis Ababa",2716200,44],
      ["Fiji","Suva",177300,159],
      ["Finland","Helsinki",1162900,93],
      ["France","Paris",9854000,12],
      ["Gabon","Libreville",661600,120],
      ["Gambia","Banjul",46700,176],
      ["Georgia","Tbilisi",1440000,80],
      ["Germany","Berlin",3933300,29],
      ["Ghana","Accra",2825800,43],
      ["Greece","Athens",3247000,34],
      ["Grenada","St. George's",4300,193],
      ["Guatemala","Guatemala City",2655900,47],
      ["Guinea","Conakry",1767200,65],
      ["Guinea-Bissau","Bissau",296900,142],
      ["Guyana","Georgetown",227700,149],
      ["Greece","Athens",3247000,34],
      ["Haiti","Port-au-Prince",1764000,66],
      ["Honduras","Tegucigalpa",1436000,81],
      ["Hungary","Budapest",2597000,49],
      ["Iceland","Reykjavik",184200,158],
      ["India","New Delhi",15334000,3],
      ["Indonesia","Jakarta",13194000,5],
      ["Iran","Tehran",7796257,16],
      ["Iraq","Baghdad",6777300,19],
      ["Ireland","Dublin",1018500,98],
      ["Israel","Jerusalem",695500,116],
      ["Italy","Rome",3550900,33],
      ["Jamaica","Kingston",937700,103],
      ["Japan","Tokyo",35327000,1],
      ["Jordan","Amman",2677500,46],
      ["Kazakhstan","Astana",288200,143],
      ["Kenya","Nairobi",3064800,37],
      ["Kiribati","Tarawa",26600,180],
      ["Korea, North","Pyongyang",3222000,36],
      ["Korea, South","Seoul",10287847,11],
      ["Kosovo","Pristina",400000,133],
      ["Kuwait","Kuwait",1709800,69],
      ["Kyrgyzstan","Bishkek",824900,106],
      ["Laos","Vientiane",194200,155],
      ["Latvia","Riga",867700,105],
      ["Lebanon","Beirut",1916100,60],
      ["Lesotho","Maseru",173700,160],
      ["Liberia","Monrovia",1348900,88],
      ["Libya","Tripoli",2357800,51],
      ["Liechtenstein","Vaduz",5300,190],
      ["Lithuania","Vilnius",543500,129],
      ["Luxembourg","Luxembourg",78800,166],
      ["Macedonia","Skopje",587300,125],
      ["Madagascar","Antananarivo",1390800,84],
      ["Malawi","Lilongwe",499200,131],
      ["Malaysia","Kuala Lumpur",3688200,31],
      ["Maldives","Malé",81600,165],
      ["Mali","Bamako",1323200,89],
      ["Malta","Valletta",194200,156],
      ["Marshall Islands","Majuro",20500,185],
      ["Mauritania","Nouakchott",661400,121],
      ["Mauritius","Port Louis",577200,127],
      ["Mexico","Mexico City",19013000,2],
      ["Micronesia","Palikir",11600,188],
      ["Moldova","Chisinau",772500,112],
      ["Monaco","Monaco",1400,195],
      ["Mongolia","Ulaan Baatar",804200,108],
      ["Montenegro","Podgorica",117875,161],
      ["Morocco","Rabat",1636600,73],
      ["Mozambique","Maputo",1691000,70],
      ["Myanmar","Rangoon",4344100,27],
      ["Namibia","Windhoek",221000,151],
      ["Nauru","Yaren",4900,192],
      ["Nepal","Kathmandu",1203100,90],
      ["Netherlands","Amsterdam",737900,115],
      ["New Zealand","Wellington",342500,139],
      ["Nicaragua","Managua",1390500,85],
      ["Niger","Niamey",748600,113],
      ["Nigeria","Abuja",590400,124],
      ["Norway","Oslo",791500,110],
      ["Oman","Muscat",797000,109],
      ["Pakistan","Islamabad",601600,123],
      ["Palau","Melekeok",1000,196],
      ["Panama","Panama City",1426000,82],
      ["Papua New Guinea","Port Moresby",343000,138],
      ["Paraguay","Asunción",2139000,56],
      ["Peru","Lima",9130000,13],
      ["Philippines","Manila",11862000,7],
      ["Poland","Warsaw",1723000,68],
      ["Portugal","Lisbon",2843000,41],
      ["Qatar","Doha",567000,128],
      ["Romania","Bucharest",1937000,59],
      ["Russia","Moscow",11621000,8],
      ["Rwanda","Kigali",1004000,99],
      ["Samoa","Apia",37000,177],
      ["San Marino","San Marino",4128,194],
      ["São Tomé and Príncipe","São Tomé",64000,171],
      ["Saudi Arabia","Riyadh",5451000,23],
      ["Senegal","Dakar",3035000,38],
      ["Serbia","Belgrade",1135000,95],
      ["Seychelles","Victoria",27000,179],
      ["Sierra Leone","Freetown",941000,102],
      ["Singapore","Singapore",5469700,22],
      ["Slovakia","Bratislava",434000,132],
      ["Slovenia","Ljubljana",273000,145],
      ["Solomon Islands","Honiara",68000,168],
      ["Somalia","Mogadishu",1554000,74],
      ["South Africa","Pretoria",1501000,78],
      ["South Sudan, Republic of","Juba",269000,146],
      ["Spain","Madrid",6574000,20],
      ["Sri Lanka","Colombo",693000,117],
      ["St. Kitts and Nevis","Basseterre",12000,187],
      ["St. Lucia","Castries",21000,184],
      ["St. Vincent and the Grenadines","Kingstown",31000,178],
      ["Sudan","Khartoum",4632000,26],
      ["Suriname","Paramaribo",278000,144],
      ["Swaziland","Mbabane",66000,169],
      ["Sweden","Stockholm",1385000,86],
      ["Switzerland","Bern",353000,137],
      ["Syria","Damascus",2650000,48],
      ["Taiwan","Taipei",6950646,18],
      ["Tajikistan","Dushanbe",739000,114],
      ["Tanzania","Dar es Salaam",3588000,32],
      ["Thailand","Bangkok",8426000,15],
      ["Togo","Lomé",1524000,77],
      ["Tonga","Nuku'alofa",25000,181],
      ["Trinidad and Tobago","Port-of-Spain",66000,170],
      ["Tunisia","Tunis",790000,111],
      ["Turkey","Ankara",4194000,28],
      ["Turkmenistan","Ashgabat",683000,119],
      ["Tuvalu","Funafuti",5000,191],
      ["Tunisia","Tunis",790000,111],
      ["Uganda","Kampala",1659000,72],
      ["Ukraine","Kyiv",2829000,42],
      ["United Arab Emirates","Abu Dhabi",942000,101],
      ["United Kingdom","London",9005000,14],
      ["United States","Washington DC",4705000,25],
      ["Uruguay","Montevideo",1672000,71],
      ["Uzbekistan","Tashkent",2227000,53],
      ["Vanuatu","Port Vila",47000,175],
      ["Venezuela","Caracas",3242000,35],
      ["Vietnam","Hanoi",2955000,39],
      ["Western Sahara","Laayoune",237000,147],
      ["Yemen","Sanaá",2419000,50],
      ["Zambia","Lusaka",1802000,61],
      ["Zimbabwe","Harare",1542000,75],
    ];

    const table1 = sheet1.tables.add("A1:D1", true);
    table1.name = "CiudadesCapitales";
    table1.getHeaderRowRange().values = [headers];
    table1.style = "TableStyleMedium3";
    table1.rows.add(undefined, data);

    // Number format for Población
    const lastRow = data.length + 1;
    sheet1.getRange(`C2:C${lastRow}`).numberFormat =
      Array(data.length).fill(["#,##0"]);

    // Lookup area — F1:G1 headers, F2 with sample value, G2 empty for student formula
    sheet1.getRange("F1").values = [["Ciudad Capital"]];
    sheet1.getRange("G1").values = [["Población"]];
    sheet1.getRange("F1:G1").format.font.bold = true;
    sheet1.getRange("F1:G1").format.font.color = "#FFFFFF";
    sheet1.getRange("F1:G1").format.fill.color = "#E07000";
    sheet1.getRange("F2").values = [["Kabul"]];

    // Border for G2 (student answer cell)
    sheet1.getRange("G2").format.borders.getItem("EdgeBottom").style = "Continuous";
    sheet1.getRange("G2").format.borders.getItem("EdgeTop").style = "Continuous";
    sheet1.getRange("G2").format.borders.getItem("EdgeLeft").style = "Continuous";
    sheet1.getRange("G2").format.borders.getItem("EdgeRight").style = "Continuous";

    sheet1.getUsedRange().format.autofitColumns();

    await context.sync();

    // ─── SHEET 2: Top 15 Ciudades ───
    const sheet2 = context.workbook.worksheets.add("Top 15 Ciudades");

    // Create pivot table from Ciudades capitales del mundo
    const srcRange = sheet1.getRange(`A1:D${lastRow}`);

    const pvt = sheet2.pivotTables.add(
      "pvtTop15",
      srcRange,
      sheet2.getRange("A3"),
    );

    pvt.hierarchies.load("items/name");
    await context.sync();

    // Rows: Ciudad Capital (student will add Clasificación above in Task 5)
    pvt.rowHierarchies.add(pvt.hierarchies.getItem("Ciudad Capital"));

    // Values: Sum of Población
    const dPob = pvt.dataHierarchies.add(
      pvt.hierarchies.getItem("Población"),
    );
    dPob.summarizeBy = "Sum";

    await context.sync();

    // Filter to top 15 cities by population
    const ciudadField = pvt.rowHierarchies
      .getItem("Ciudad Capital")
      .fields.getItem("Ciudad Capital");

    ciudadField.applyFilter({
      manualFilter: {
        selectedItems: [
          "Tokyo",
          "Mexico City",
          "New Delhi",
          "Buenos Aires",
          "Jakarta",
          "Dhaka",
          "Manila",
          "Moscow",
          "Cairo",
          "Beijing",
          "Seoul",
          "Paris",
          "Lima",
          "London",
          "Bangkok",
        ],
      },
    });

    await context.sync();

    // Pivot chart: clustered column starting at D3
    const pivotChart = sheet2.charts.add(
      Excel.ChartType.columnClustered,
      sheet2.getRange("A3"),
      Excel.ChartSeriesBy.auto,
    );
    pivotChart.setPosition("D3");

    await context.sync();

    // Activate first sheet
    sheet1.activate();
    sheet1.getRange("A1").select();

    await context.sync();
  });
}
